import './Stepper.css';

/**
 * Indicador de pasos del wizard.
 * - pasos: array de strings (etiquetas)
 * - actual: índice del paso activo (0-based)
 */
export default function Stepper({ pasos, actual }) {
  return (
    <ol className="stepper" aria-label="Progreso de la búsqueda">
      {pasos.map((label, i) => {
        const estado = i < actual ? 'stepper-done' : i === actual ? 'stepper-active' : '';
        return (
          <li key={label} className={`stepper-step ${estado}`}>
            <span className="stepper-num" aria-hidden="true">{i < actual ? '✓' : i + 1}</span>
            <span className="stepper-label">{label}</span>
            <span className="sr-only">
              {i < actual ? '(completado)' : i === actual ? '(paso actual)' : ''}
            </span>
            {i < pasos.length - 1 && <span className="stepper-line" aria-hidden="true" />}
          </li>
        );
      })}
    </ol>
  );
}